import { render, staticRenderFns } from "./dataForm.vue?vue&type=template&id=5ab811b5&scoped=true&"
import script from "./dataForm.vue?vue&type=script&lang=js&"
export * from "./dataForm.vue?vue&type=script&lang=js&"
import style0 from "./dataForm.vue?vue&type=style&index=0&id=5ab811b5&lang=less&scoped=true&"
import style1 from "./dataForm.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab811b5",
  null
  
)

export default component.exports